import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "clone-icon",
  "use": "clone-icon-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"clone-icon\">\n<path d=\"M20.25 24H9.75C8.508 24 7.5 22.992 7.5 21.75V6.75C7.5 5.508 8.508 4.5 9.75 4.5H20.25C21.492 4.5 22.5 5.508 22.5 6.75V21.75C22.5 22.992 21.492 24 20.25 24Z\" fill=\"currentColor\" />\n<path d=\"M18 3H8.25C7.008 3 6 4.008 6 5.25V19.5H5.25C4.008 19.5 3 18.492 3 17.25V2.25C3 1.008 4.008 0 5.25 0H15.75C16.992 0 18 1.008 18 2.25V3Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol